import { useContext, useState } from "react"
import { Button, Card, Form } from "react-bootstrap"
import { withTranslation } from "react-i18next"
import Get from "../../api/Get"
import { APPOINTMENT_EXTEND_TIME } from "../../api/Routes"
import { authContext } from "../../context/AuthContext"
import ComponentModalErrorSever from "../ComponentModalErrorSever"

function FormExtraTime({t, idCita, setIsAlmostDown, setShowExtraTime, setShowFormET, showFormET, setNewEndDate}){
    const {auth} = useContext(authContext)
    const [time, setTime] = useState('')
    const [isSubmiting,setIsSubmiting] = useState(false)

    //console.log('formExtraTime....')

    //server error
    const [showModalError, setShowModalError] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const handleClose = () => setShowModalError(false)

    const agregarTiempo = () =>{
        setIsSubmiting(true)
        let url = `${APPOINTMENT_EXTEND_TIME}?id=${idCita}&time=${time}`
        Get({url: url, access_token: auth.data.access_token})
        .then(response=>{
            //console.log(response)
            if(response.data.state){
                setIsAlmostDown(false)
                setShowExtraTime(false)
                setShowFormET(false) 
                setTime('')
                setNewEndDate(response.data.data.message)             
            }else{
                setShowModalError(true)
                setErrorServer(response)
            }
            setIsSubmiting(false)
        })
        .catch(error=>{
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
            setIsSubmiting(false)
        })
    }

    return (
        showFormET &&
        <Card className="shadow-sm">
            <Card.Body>
                <div className="d-flex align-items-center justify-content-around">
                    <div>Tiempo adicional</div>
                    <div>
                        <Form.Control
                            type="number"
                            min="1"
                            className="input-form"
                            value={time}
                            onChange={e=>{
                                let regex = /^\d*[1-9]\d*$/;
                                if(regex.test(e.target.value) ){
                                    setTime(e.target.value)
                                }else  if(e.target.value === ""){
                                    setTime(e.target.value)
                                }
                            }} 
                        />
                    </div>
                    <div>
                        <Button onClick={agregarTiempo} variant="outline-primary" disabled={isSubmiting}>
                            {
                                isSubmiting ? <div className="spinner-border text-primary" role="status"><span className="sr-only">Loading...</span></div> : 
                                'Aceptar'
                            }
                            
                        </Button>
                    </div>
                </div>
                <ComponentModalErrorSever 
                    show={showModalError}
                    handleClose={handleClose}
                    error={errorServer}
                />
            </Card.Body>
        </Card>
        
    )
}

export default withTranslation()(FormExtraTime)